export default "__VITE_ASSET__fb11657c__"